var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"two-column-block",class:{ reverse: _vm.reverse }},[_c('div',{staticClass:"column-one"},[_vm._t("column-one")],2),_vm._v(" "),_c('div',{staticClass:"column-two"},[_vm._t("column-two")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }